import { Box, Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

type PageHeaderProps = {
  title: string;
  description?: ReactNode;
  /** Small line above the title — section name, breadcrumb-ish context. */
  eyebrow?: string;
  actions?: ReactNode;
};

/** Consistent page opening used by every route (§8 — one pattern, reused). */
export function PageHeader({ title, description, eyebrow, actions }: PageHeaderProps) {
  return (
    <Group justify="space-between" align="flex-end" wrap="wrap" gap="md" mb="lg">
      <Stack gap={4} style={{ minWidth: 0 }}>
        {eyebrow ? (
          <Text size="xs" fw={600} tt="uppercase" c="var(--text-subtle)" lts="0.08em">
            {eyebrow}
          </Text>
        ) : null}
        <Title order={1}>{title}</Title>
        {description ? (
          <Box maw={640}>
            {/*
              `component="div"`: callers pass badges and groups here, and a <p>
              may not contain a <div> — React reports that as a console error.
            */}
            <Text component="div" c="var(--text-muted)" size="md">
              {description}
            </Text>
          </Box>
        ) : null}
      </Stack>
      {actions ? <Group gap="sm">{actions}</Group> : null}
    </Group>
  );
}
